import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Badge, Nav } from 'react-bootstrap';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from './firebase';
import './MainContent.css';
import { getForumsWithMessageCounts } from './util_code/get_forum_messages';
import { useNavigate, Link } from 'react-router-dom';
import { Divider } from 'antd';

const MainContent = () => {
  const [recentAds, setRecentAds] = useState([]);
  const [forums, setForums] = useState([]);
  const [activeTab, setActiveTab] = useState('featured');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentBanner, setCurrentBanner] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const bannerInterval = setInterval(() => {
      setCurrentBanner((prev) => (prev % 4) + 1);
    }, 5000);

    return () => clearInterval(bannerInterval); 
  }, []);

  useEffect(() => {
    const fetchRecentData = async () => {
      try {
        const adsQuery = query(collection(db, 'ads'), orderBy('createdAt', 'desc'), limit(10));
        const adsSnapshot = await getDocs(adsQuery);
        setRecentAds(adsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));

        const forumsWithCounts = await getForumsWithMessageCounts();
        setForums(forumsWithCounts.slice(0, 5));
      } catch (error) {
        console.error("Error fetching data:", error);
        setRecentAds([]);
        setForums([]);
      }
    };

    fetchRecentData();
  }, []);

  const placeholderClubChats = [
    { id: 'placeholder1', name: 'Welcome to Club Chat' },
  ];

  const handleAdClick = (adId) => {
    navigate(`/view-ad/${adId}`);
  };

  const handleForumClick = (forumId) => {
    navigate(`/forums`);
  };

  const FeaturedAdsSection = () => (
    <div className="featured-ads-container">
      <div className="featured-ads-scroll">
        {recentAds.length > 0 ? (
          recentAds.map(ad => (
            <div className="featured-ad-item" key={ad.id}>
              <Card className="ad-card" onClick={() => handleAdClick(ad.id)}>
                <div className='featured-image-container-main'>
                  <div className="featured-image-container">
                    <Card.Img 
                      variant="top" 
                      src={ad.imageUrls ? ad.imageUrls[0] : ad.imageUrl} 
                      className="featured-image"
                    />
                  </div>
                </div>
                <Card.Body>
                  <Card.Title className="ad-title">{ad.ItemName}</Card.Title>
                  <Card.Text>Price: R{ad.Price}</Card.Text>
                </Card.Body>
              </Card>
            </div>
          ))
        ) : (
          <p>No recent ads available.</p>
        )}
      </div>
    </div>
  );

  const ClubChatSection = () => (
    <div className="chat-container-main">
      <h3>Club Chat</h3>
      {placeholderClubChats.map(chat => (
        <div key={chat.id} className="chat-item">
          <h4>{chat.name}</h4>
        </div>
      ))}
    </div>
  );

  const ForumsSection = () => (
    <>
      {!isMobile && (
        <div className='heading-row'>
          <Link to="/forums" className="section-heading">
            <h3 style={{ display: 'flex', alignItems: 'center' }}>
              Forum Topics
              <img 
                src="/T_message.svg" 
                alt="Forum icon" 
                className="forum-icon" 
                style={{ 
                  marginRight: '8px', 
                  marginLeft: '8px', 
                  width: '50px', 
                  height: '50px'
                }} 
              />
            </h3>
          </Link>
        </div>
      )}
      <div className="chat-container-main">
        {isMobile && <h3>Forum Topics</h3>}
        {forums.length > 0 ? (
          forums.map(forum => (
            <div 
              key={forum.id} 
              className="chat-item forum-row"
              onClick={() => handleForumClick(forum.id)}
            >
              <div className="forum-name">{forum.name}</div>
              <div className="forum-stats">
                <span className="users-count">{forum.userCount} Users</span>
                <span className="message-count">{forum.messageCount} Messages</span>
              </div>
            </div>
          ))
        ) : (
          <p>No forums available.</p>
        )}
      </div>
    </>
  );

  return (
    <Container className='main-content'>
      <Row>
        <Col className="ad-banner p-0">
          <img 
            src={`/Banner${currentBanner}.svg`} 
            alt={`Totly Store Banner ${currentBanner}`} 
            className="img-fluid w-100" 
            style={{ transition: 'opacity 0.5s ease-in-out' }}
          />
        </Col>
      </Row>
      <Row>
        <Col className="px-0">
          <Divider className="my-4 mx-0" />
        </Col>
      </Row>
      {isMobile ? (
        <>
          <div className="mobile-tabs-container">
            <Nav variant="tabs" className="mobile-tabs">
              <Nav.Item>
                <Nav.Link 
                  eventKey="featured" 
                  active={activeTab === 'featured'}
                  onClick={() => setActiveTab('featured')}
                >
                  Featured Ads
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link 
                  eventKey="forums" 
                  active={activeTab === 'forums'}
                  onClick={() => setActiveTab('forums')}
                >
                  Forums
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="mobile-tab-content">
            {activeTab === 'featured' && (
              <>
                <Divider className="my-4 mx-0" />
                <FeaturedAdsSection />
              </>
            )}
            {activeTab === 'forums' && <ForumsSection />}
          </div>
        </>
      ) : (
        <>
          <Row className="mb-4">
            <Col md={12} className='heading-row px-0' >
              <Link to="/buysell" className="section-heading">
                <h3 style={{ display: 'flex', alignItems: 'center' }}>
                  Featured Ads
                  <img 
                    src="/T_trollie.svg" 
                    alt="Trolley icon" 
                    className="trolley-icon" 
                    style={{ 
                      marginRight: '8px', 
                      marginLeft: '8px', 
                      width: '50px', 
                      height: '50px'
                    }} 
                  />
                </h3>
              </Link>
            </Col>
            <Col md={12} className="px-0">
              <FeaturedAdsSection />
            </Col>
          </Row>
          <Divider className="my-4 mx-0" />
          <Row className="chat-sections">
            <Col md={6} className="px-0">
              <ForumsSection />
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default MainContent;